/**
 * @generated SignedSource<<d4bae6a6106552600fefeb701f2b2fa1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ArtistViewTeam_teamMembers$data = {
  readonly offers: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"TeamList_offers">;
      } | null;
    } | null>;
  };
  readonly " $fragmentType": "ArtistViewTeam_teamMembers";
};
export type ArtistViewTeam_teamMembers$key = {
  readonly " $data"?: ArtistViewTeam_teamMembers$data;
  readonly " $fragmentSpreads": FragmentRefs<"ArtistViewTeam_teamMembers">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ArtistViewTeam_teamMembers",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "isAccepted",
          "value": true
        }
      ],
      "concreteType": "OfferNodeConnection",
      "kind": "LinkedField",
      "name": "offers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OfferNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OfferNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TeamList_offers"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "offers(isAccepted:true)"
    }
  ],
  "type": "ArtistNode",
  "abstractKey": null
};

(node as any).hash = "dc11ec57c44258c4e122bf6994e94bb7";

export default node;
